import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

const EditBarcodeResponseModalBody = () => {
  return (
    <div id='editbarcoderesponsemodalbody-wrapper'>
      <div id='editbarcoderesponsemodalbody-error-icon' className="flex flex-row bg-[#fff0f0] border-solid border-[1px] border-l-4 border-[#FF5252] py-3 px-2 mb-3">
        <RMSvgIcon id='editbarcoderesponsemodalbody-error-svg-icon' name="Error" fill="#FF5252" width="5rem" className="" />
        <div id='editbarcoderesponsemodalbody-error-message'>Plate barcode already exists</div>
      </div>
      <span id='editbarcoderesponsemodalbody-feedback-text' className="text-[#5D5D5D]">
        The barcode ID already exists. Please create a unique barcode ID Additional
        Information
      </span>
    </div>
  );
};

export default EditBarcodeResponseModalBody;
